import http from "../utils/http";

export const getCurrencies = async (): Promise<Response> => {
  return await http.get("/api/currencies");
};
